/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { GET_POLICY_LIST } from '@pages/PayoutListPage/apis/graphql';
import { credentialPayoutListConfig } from '../../config/credentialLists.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { useEventId } from '../../provider';
import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IPoliciesListMethods extends IPluginMethodMap {
  getPoliciesListProps(args: any): Promise<any>;
}

export class PoliciesListPlugin implements IAgentPlugin {
  readonly methods: IPoliciesListMethods;

  constructor() {
    this.methods = {
      getPoliciesListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    return await this.getPoliciesList(args);
    // return {
    //   credential:credentialPayoutListConfig
    //  };
  }

  private async getPoliciesList(args: any) {
    const { eventId } = useEventId();
    let _where1 = args?.where?.filter(
      (item: any) =>
        item?.column === 'policyNumber' || item?.column === 'status'
    );
    let _where2 = args?.where?.filter(
      (item: any) =>
        item?.column !== 'policyNumber' && item?.column !== 'status'
    );
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_POLICY_LIST, {
          input: {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 10,
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
            where: [..._where1],
            relationFilter: {
              purchaser: {
                where: [..._where2],
                limit: args?.size ?? 10,
                skip: args?.offset ?? 0,
              },
            },
          },
        })
        .toPromise();
      if (res?.data) {
        console.log(`table data`, res);
        let _rowData = this.formatTable(res?.data?.getListOfPayout?.data);
        return {
          ...credentialPayoutListConfig,
          ultUsers: _rowData,
          isEmpty: res?.data?.getListOfPayout?.data?.length <= 0,
          // studentGroup: holderGroups,
          activePage: res?.data?.getListOfPayout?.currentPage,
          pageSize: res?.data?.getListOfPayout?.pageSize,
          totalCount: res?.data?.getListOfPayout?.totalCount,
          totalPages: res?.data?.getListOfPayout?.totalPages,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          pid: item?.id,
          id: item?.policyId,
          vid: item?.purchaser?.vuid,
          status: item?.status,
          payout: item?.amount,
          policyNo: item?.policyNumber,
          name: `${item?.purchaser?.firstName} ${item?.purchaser?.lastName}`,
          email: item?.purchaser?.email,
          // image:item?.image,
          dateCreated: item?.policy?.purchasedAt
            ? moment(item?.policy?.purchasedAt).format('LLL')
            : '-',
          coverage: item?.policy?.coverage,
          premium: item?.policy?.premium,
          policyOption: `Policy Option ${item?.policy?.policyOption}`,
        };
      });
    return _rowData;
  }
}
